// eslint-disable-next-line import/no-cycle
import router from '@/app/router';

export default function noContract({ next, store }) {
	if (store.state.contract) {
		return router.push('/main-page');
	}
	return next();
}
